import { render, staticRenderFns } from "./CourseListItem.vue?vue&type=template&id=7e45c152&"
import script from "./CourseListItem.vue?vue&type=script&lang=js&"
export * from "./CourseListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e45c152')) {
      api.createRecord('7e45c152', component.options)
    } else {
      api.reload('7e45c152', component.options)
    }
    module.hot.accept("./CourseListItem.vue?vue&type=template&id=7e45c152&", function () {
      api.rerender('7e45c152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/CourseListItem.vue"
export default component.exports